<template>
  <div class="bdg-simple-list">
    <div class="list-item" :key="`list_item_${i}`" v-for="(item, i) in items">
      {{ item }}
    </div>
  </div>
</template>

<script>
export default {
  name: "BdgSimpleList",
  props: {
    items: Array
  }
};
</script>

<style lang="scss" scoped>
.bdg-simple-list {
  .list-item {
    @apply border border-lightgray py-3 px-4 bg-white;

    &:not(:first-child) {
      @apply border-t-0;
    }
  }
}

.bdg-table {
  .table {
    &.striped {
      .body {
        .body-row {
          &:nth-child(odd) {
            .table-cell {
              .simple-list-cell {
                .bdg-simple-list {
                  .list-item {
                    @apply bg-white;
                  }
                }
              }
            }
          }

          &:nth-child(even) {
            .table-cell {
              .simple-list-cell {
                .bdg-simple-list {
                  .list-item {
                    @apply bg-lightgray-lightest;
                  }
                }
              }
            }
          }
        }
      }
    }

    /*.body {*/
    /*  .body-row {*/
    /*    &:not(:first-child) {*/
    /*      .table-cell {*/
    /*        .simple-list-cell {*/
    /*          .bdg-simple-list {*/
    /*            .list-item {*/
    /*              @apply border-t-0;*/
    /*            }*/
    /*          }*/
    /*        }*/
    /*      }*/
    /*    }*/
    /*  }*/
    /*}*/
  }
}
</style>
